import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zhCN from 'vee-validate/dist/locale/zh_CN'
import zhTW from 'vee-validate/dist/locale/zh_TW'
import en from 'vee-validate/dist/locale/en'
import th from 'vee-validate/dist/locale/th'
import ja from 'vee-validate/dist/locale/ja'

let lang = localStorage.getItem('lang') || 'zh_HK'
if (lang === 'zh' || lang === 'cn') {
    lang = 'zh_CN'
} else if (lang === 'zh_HK') {
    lang = 'zh_TW'
}

switch (lang) {
    case 'zh_TW':
    case 'zh_HK':
        Validator.localize('zh_TW', zhTW)
        break
    case 'zh_CN':
        Validator.localize('zh_CN', zhCN)
        break
    case 'th':
        Validator.localize('th', th)
        break
    case 'ja':
        Validator.localize('ja', ja)
        break
    default:
        Validator.localize('en', en)
}

Vue.use(VeeValidate, {
    locale: lang
})



// WEBPACK FOOTER //
// ./src/lib/validate/validate.js